































































































































import { Component, Vue } from 'vue-property-decorator';
import cloneDeep from 'lodash/cloneDeep';

// Services
import Staff from '@/services/Staff';
import * as Sentry from '@sentry/browser';
import Claims from '@/services/Claims';

// Components
import Checkbox from '@/components/Form/Checkbox.vue';
import TextField from '@/components/Form/TextField.vue';
import Alert from '@/components/Global/Alert.vue';
import Loading from '@/components/Global/Loading.vue';
import Search from '@/components/Staff/Payments/Search.vue';

import moment from 'moment-timezone';

import {
	ClaimBrandFilterOption,
	ClaimBrandFilter,
	ClaimSetupFilter,
	ClaimSetupFilterOption,
} from './claim-filters';
import { ClaimViewModel } from './claim-types';

@Component({
	name: 'PageStaffClaims',
	components: {
		Loading,
		Alert,
		Search
	},
})
export default class ClaimsList extends Vue {
	private error: boolean = false;
	private loading: boolean = true;

	private claims: ClaimViewModel[] = [];

	private filteredClaims: ClaimViewModel[] = [];
	private readonly brandFilter = new ClaimBrandFilter();
	private readonly setupFilter = new ClaimSetupFilter();

	private paginate: string[] = ['filteredClaims'];

	private async created() {
		try {
			// Get claims
			const getClaims = await Staff.getClaims();
			if (Array.isArray(getClaims.data)) {
				this.claims = getClaims.data
					.map(claim => {
						// In DEV (and only DEV), claim records more often than not have claim
						// data in a `data` property rather than `claim_data`. This corrects
						// that problem.
						if (claim.data && !claim.claim_data) {
							claim.claim_data = claim.data;
						}
						return claim;
					})
					.map(ClaimViewModel.create);

				this.claims = this.claims.sort((a, b) => {
					return new Date(a.dateSubmitted) > new Date(b.dateSubmitted)
						? -1
						: new Date(a.dateSubmitted) < new Date(b.dateSubmitted)
						? 1
						: 0;
				});
				this.filterClaims();
			}
		} catch (e) {
			Sentry.captureException(e);
			this.error = true;
		} finally {
			this.loading = false;
		}
	}

	private filterClaims(): void {
		const that = this;
		this.filteredClaims = this.claims.filter((claim: ClaimViewModel): boolean => {
			return that.brandFilter.filter(claim) && that.setupFilter.filter(claim);
		});

		console.log('filtered claims', this.filteredClaims);
	}

	private formatDate(date) {
		return moment.tz( date, 'America/Chicago' ).format( 'MM/D/YYYY hh:mma' );
	}
}
